import React from 'react'
import { BasicFeature } from '@scentregroup/shared/hub-components/basic-feature'
import getDescriptiveLocation from '@scentregroup/shared/helpers/get-descriptive-location'
import { TradingHourDay } from '@scentregroup/shared-graphql'
import { SGPageTemplate } from '@scentregroup/shared/types/page-templates'
import { Template } from '@scentregroup/shared/components/page-templates/template'
import { ContentDetail } from '../../../lib/get-content-detail'
import { Centre } from '../../../lib/get-centre-by-slug'
import { createRetailerUtilityfromStore } from '../../../lib/createRetailerUtilityfromStore'

export function StoryContentDetail({
  centre,
  template,
  content,
  tradingHours,
}: {
  template?: SGPageTemplate
  content: ContentDetail['story']
  centre?: Centre
  tradingHours?: TradingHourDay[]
}): JSX.Element {
  const { title, bodyCopy: body } = content
  const supportingColor = content?.heroImageSet?.masterSupportingColour
  const heroImage = content?.heroImageSet?.master?.url
  const store = content?.storesCollection?.featuredStoreForCentre

  const retailerUtility = createRetailerUtilityfromStore(
    store,
    tradingHours,
    centre?.timeZone,
    centre?.slug
  )
  const location = getDescriptiveLocation({
    physicalAddress: store?.physicalAddress || '',
    storeTitle: store?.title || '',
  })

  return (
    <>
      <BasicFeature
        title={title}
        body={body}
        location={location}
        supportingColor={supportingColor}
        heroImage={heroImage}
        timeZone={centre?.timeZone}
        retailerUtility={retailerUtility}
      />
      {template && <Template template={template} />}
    </>
  )
}
